import { render, staticRenderFns } from "./helpFriend.vue?vue&type=template&id=30f58a09&scoped=true"
import script from "./helpFriend.vue?vue&type=script&lang=js"
export * from "./helpFriend.vue?vue&type=script&lang=js"
import style0 from "./helpFriend.vue?vue&type=style&index=0&id=30f58a09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f58a09",
  null
  
)

export default component.exports